(() => {
  const setup = () => {
    const drawer = document.getElementById('t4s-search-hidden');
    if (!drawer) return;
    let open = false;
    let opener = null;
    const isOpen = () => drawer.getAttribute('aria-hidden') === 'false';
    const focusable = () => [...drawer.querySelectorAll('a[href],button,input,select,textarea,[tabindex]')].filter(element =>
      !element.disabled && element.tabIndex >= 0 && !element.closest('[inert],[hidden],[aria-hidden="true"]') &&
      element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden'
    );
    const focusFirst = () => {
      const input = drawer.querySelector('input[data-input-search]');
      (input || focusable()[0] || drawer).focus({preventScroll:true});
    };
    document.addEventListener('click', event => {
      const trigger = event.target.closest('[data-drawer-options]');
      if (trigger && (trigger.getAttribute('data-drawer-options') || '').includes('#t4s-search-hidden')) opener = trigger;
    }, true);
    const sync = () => {
      const next = isOpen();
      drawer.inert = !next;
      drawer.setAttribute('role','dialog');
      drawer.setAttribute('tabindex','-1');
      const label = drawer.querySelector('.t4s-drawer__header > span')?.textContent.trim();
      if (label) drawer.setAttribute('aria-label',label);
      if (next) drawer.setAttribute('aria-modal','true');
      else drawer.removeAttribute('aria-modal');
      if (next && !open) requestAnimationFrame(() => {if (isOpen()) focusFirst();});
      if (!next && open && opener?.isConnected) opener.focus({preventScroll:true});
      open = next;
    };
    new MutationObserver(sync).observe(drawer,{attributes:true,attributeFilter:['aria-hidden'],childList:true});
    document.addEventListener('keydown', event => {
      if (!isOpen()) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopImmediatePropagation();
        drawer.querySelector('[data-drawer-close]')?.click();
        return;
      }
      if (event.key !== 'Tab') return;
      const items = focusable();
      const first = items[0], last = items[items.length-1];
      if (!first) {event.preventDefault();drawer.focus();return;}
      if (!drawer.contains(document.activeElement) || (!event.shiftKey && document.activeElement === last) || (event.shiftKey && document.activeElement === first)) {
        event.preventDefault();
        (event.shiftKey ? last : first).focus();
      }
    }, true);
    drawer.addEventListener('transitionend', () => {
      if (isOpen() && !drawer.contains(document.activeElement)) focusFirst();
    });
    sync();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',setup,{once:true});
  else setup();
})();
